module.exports = __webpack_public_path__ + "media/images/sp/stores/kamakura/main-visual-1814a2b3e1442d52beca614502a03afe.jpg";